<template>

    <div v-if="this.$root.shared.avatarsVisible" class="absolute w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">

        <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 24rem;">

            <h2 class="text-theme-discrete font-bold text-xl p-4">{{ translate('up-avatar-select') }}</h2>

            <p class="text-theme-discrete text-base pt-2 pb-4 pl-4 mb-4">{{ translate('up-avatar-select-description') }}</p>

            <div style="display: grid; grid-template-columns: repeat(auto-fill,minmax(64px, 1fr));">
                <img v-for="(avatar_file, index) in avatarCollection" :key="index" class="mb-4 cursor-pointer opacity-50 hover:opacity-100" :src="avatar_file" :alt="index" @click="changeAvatar(avatar_file)">
            </div>

        <button type="button" class="mt-4 ml-1 bg-theme-level4 hover:bg-theme-level2 text-theme-discrete hover:text-theme-control-label font-bold w-32 h-12 py-2 px-4 rounded focus:outline-none focus:shadow-outline" @click="hideAvatars">
            {{ translate('cancel') }}
        </button>

        </div>


    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {

            return {

                avatarCollection: JSON.parse(this.avatar_files),

            }

        },

        props: [
            'avatar_files',
            'language'
        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            hideAvatars() {

                this.$root.shared.avatarsVisible = false

            },

            changeAvatar(file) {

                // let filename = file.split('/').pop().split('#')[0].split('?')[0];
                // alert('Going to: ' + '/' + this.language + '/avatar/update/' + file)
                window.location = '/' + this.language + '/avatar/update/' + file

            }

        }

    }

</script>
